import { ReminderHistory } from '../../lib/types/models/reminder-history/reminder-history'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const getEnrollmentRemindersHistory = async (
  enrollmentId: number,
  type: 'general' | 'accounting'
) => {
  return restApiClient
    .url(
      encodeNestedObject(
        constructApiUrl(API.enrollments.getRemindersHistory.url, { id: enrollmentId }),
        { type }
      )
    )
    .get<ReminderHistory[]>()
}
